export enum StoreDebtEventType {
  GIFT_CARD_REDEMPTION = "GIFT_CARD_REDEMPTION",
  GIFT_CARD_REFUND = "GIFT_CARD_REFUND",
  CREDIT_NOTE_REDEMPTION = "CREDIT_NOTE_REDEMPTION",
  CREDIT_NOTE_REFUND = "CREDIT_NOTE_REFUND",
  SETTLEMENT = "SETTLEMENT",
}
